import { hotRankList } from '@/mocks/gossipEvents';

const tagStyles: Record<string, string> = {
  反转: 'bg-primary-100 text-primary-700 dark:bg-primary-900 dark:text-primary-200',
  跟进: 'bg-secondary-100 text-secondary-900 dark:bg-secondary-900 dark:text-secondary-100',
  回应: 'bg-accent-100 text-accent-900 dark:bg-accent-900 dark:text-accent-100',
  完结: 'bg-background-200 text-foreground-600 dark:bg-background-800 dark:text-foreground-300',
};

function formatHeat(value: number) {
  if (value >= 10000) return `${(value / 10000).toFixed(1)}万`;
  return String(value);
}

export default function HotRankList() {
  return (
    <div className="rounded-lg border border-background-200/70 bg-background-100 p-4 md:p-5">
      <div className="flex items-center justify-between">
        <h3 className="font-heading text-lg text-foreground-950 flex items-center gap-2">
          <i className="ri-fire-fill text-primary-500"></i>
          实时热榜
        </h3>
        <span className="text-xs text-foreground-500 flex items-center gap-1">
          <i className="ri-refresh-line"></i>
          刚刚更新
        </span>
      </div>

      <ul className="mt-4 flex flex-col">
        {hotRankList.map((item) => (
          <li key={item.rank}>
            <a
              href={`#${item.id}`}
              className="flex items-center gap-3 py-2.5 group cursor-pointer border-b border-background-200/60 last:border-0"
            >
              <span
                className={`w-6 h-6 shrink-0 rounded-md flex items-center justify-center text-xs font-bold font-label ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
                    : 'bg-background-200 text-foreground-600 dark:bg-background-800 dark:text-foreground-300'
                }`}
              >
                {item.rank}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-sm text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
                <div className="mt-1 flex items-center gap-2">
                  <span className={`text-[10px] px-1.5 py-0.5 rounded font-label ${tagStyles[item.tag] || tagStyles.跟进}`}>
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{formatHeat(item.heat)} 热度</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors"></i>
            </a>
          </li>
        ))}
      </ul>

      <a
        href="#hot"
        className="mt-4 flex items-center justify-center gap-1 w-full rounded-md border border-background-300/70 py-2 text-sm text-foreground-700 hover:bg-background-50 transition-colors cursor-pointer"
      >
        查看完整榜单
        <i className="ri-arrow-down-line"></i>
      </a>
    </div>
  );
}